import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = {
  key: 0,
  class: "mocked"
}
const _hoisted_5 = { class: "p-tabview p-tabview--custom all-plant-devices" }
const _hoisted_6 = {
  class: "p-tabview-nav",
  role: "tablist"
}
const _hoisted_7 = { class: "p-tabview-title d-inline-flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "bt-icon bt-icon--sm text-danger mr-2"
}
const _hoisted_9 = { class: "mt-4 mb-5 row" }
const _hoisted_10 = { class: "col-12 col-lg-auto d-flex align-items-center mb-3 mb-lg-0" }
const _hoisted_11 = { class: "mb-0 mr-3 text-gray" }
const _hoisted_12 = { class: "menu-filters menu-filters--custom" }
const _hoisted_13 = { class: "col-auto d-flex align-items-center mb-3 mb-lg-0" }
const _hoisted_14 = { class: "mb-0 mr-3 text-gray" }
const _hoisted_15 = { class: "menu-filters" }
const _hoisted_16 = { class: "col-auto d-flex align-items-center mb-3 mb-lg-0" }
const _hoisted_17 = { class: "mb-0 mr-3 text-gray" }
const _hoisted_18 = { class: "menu-filters" }
const _hoisted_19 = {
  key: 0,
  class: "row row--devices"
}
const _hoisted_20 = { class: "col-12 col-xl-6" }
const _hoisted_21 = { class: "devices-grid px-3" }
const _hoisted_22 = {
  key: 0,
  class: "col-6"
}
const _hoisted_23 = { class: "device-list-detail" }
const _hoisted_24 = { class: "px-3" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-2" }, null, -1)
const _hoisted_26 = { class: "mb-3 d-flex" }
const _hoisted_27 = { class: "fs-20 w-100 fw-bold" }
const _hoisted_28 = { class: "mb-2 fw-bold" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = {
  key: 1,
  class: "col-6 d-none d-xl-flex justify-content-center align-items-center"
}
const _hoisted_31 = { class: "mb-5 text-gray" }
const _hoisted_32 = {
  key: 1,
  class: "py-5 text-center"
}
const _hoisted_33 = { class: "fs-18 text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Divider = _resolveComponent("Divider")
  const _component_PlantDevicesItem = _resolveComponent("PlantDevicesItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_ModuleItem = _resolveComponent("ModuleItem")
  const _component_PlantDevicesSettings = _resolveComponent("PlantDevicesSettings")
  const _component_PlantDevicesAnomaly = _resolveComponent("PlantDevicesAnomaly")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode(_component_router_link, {
        to: _ctx.backLink,
        class: "fs-18 text-decoration-none text-gray"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentPlant.name), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.Devices")), 1),
        (_ctx.devicesPageAddDeviceEnabled)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_Button, { class: "p-button-rounded p-button-raised p-button--m ml-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("plantDetail.addDevice")), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("ul", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabsFilters, (tab) => {
          return (_openBlock(), _createBlock("li", {
            role: "presentation",
            key: tab.value,
            class: { 'p-highlight': _ctx.selectedTab === tab.value }
          }, [
            _createVNode("a", {
              role: "tab",
              onClick: ($event: any) => (_ctx.selectedTab = tab.value),
              class: "p-tabview-nav-link",
              "aria-selected": "false"
            }, [
              _createVNode("span", _hoisted_7, [
                (tab.value === 4)
                  ? (_openBlock(), _createBlock("span", _hoisted_8, [
                      _createVNode(_component_InlineSvgScoped, {
                        style: {"width":"18px"},
                        src: 
                                    require('@/assets/images/icons/icon-alert-hight-full.svg')
                                ,
                        "aria-label": "icon-alert-hight-full"
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(tab.label), 1)
              ])
            ], 8, ["onClick"])
          ], 2))
        }), 128))
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("AppResource.Function")) + ": ", 1),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.selectedFunction,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFunction = $event)),
              options: _ctx.functionList,
              dataKey: "value",
              optionLabel: "label",
              class: "menu-filters__buttons"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_Divider, {
          layout: "vertical",
          class: "col-auto d-none d-lg-block mb-3 mb-lg-0"
        }),
        _createVNode("div", _hoisted_13, [
          _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.SystemLower")) + ": ", 1),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.selectedSystem,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedSystem = $event)),
              options: _ctx.systemList,
              dataKey: "value",
              optionLabel: "label",
              class: "menu-filters__buttons"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_Divider, {
          layout: "vertical",
          class: "d-none d-md-block col-auto mb-3 mb-lg-0"
        }),
        _createVNode("div", _hoisted_16, [
          _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("AppResource.TypeOfComponent")) + ": ", 1),
          _createVNode("div", _hoisted_18, [
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.selectedComponentType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedComponentType = $event)),
              options: _ctx.componetTypeList,
              dataKey: "value",
              optionLabel: "label",
              class: "menu-filters__buttons"
            }, null, 8, ["modelValue", "options"])
          ])
        ])
      ]),
      (_ctx.filteredDevices && _ctx.filteredDevices.length)
        ? (_openBlock(), _createBlock("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_ElScrollbar, { class: "devices-list" }, {
                default: _withCtx(() => [
                  _createVNode("div", _hoisted_21, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredDevices, (device) => {
                      return (_openBlock(), _createBlock(_component_PlantDevicesItem, {
                        key: device.Id,
                        device: device,
                        class: "mb-2",
                        onClick: ($event: any) => (_ctx.goToDeviceDetail(device))
                      }, null, 8, ["device", "onClick"]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]),
            (_ctx.selectedDevice)
              ? (_openBlock(), _createBlock("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode(_component_ElScrollbar, null, {
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_24, [
                          _createVNode(_component_Button, {
                            class: "fs-18 text-gray mb-3 d-lg-none p-button-text pl-0",
                            onClick: _ctx.unselectDevice
                          }, {
                            default: _withCtx(() => [
                              _hoisted_25,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.$t("AppResource.Devices")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode("div", _hoisted_26, [
                            _createVNode("p", _hoisted_27, _toDisplayString(_ctx.selectedDevice.model) + ", ID:" + _toDisplayString(_ctx.selectedDevice.id), 1)
                          ]),
                          _createVNode("p", _hoisted_28, _toDisplayString(_ctx.slotsTitle), 1),
                          _createVNode("div", _hoisted_29, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedDeviceSlots, (theSlot) => {
                              return (_openBlock(), _createBlock(_component_ModuleItem, {
                                key: `device-slot-${theSlot.id}`,
                                class: "card--slim card--device mb-2",
                                "the-slot": theSlot
                              }, null, 8, ["the-slot"]))
                            }), 128)),
                            (
                                        _ctx.currentPlant.desktopId != null &&
                                        _ctx.selectedDevice.settingsVisibility
                                            .hasSettings
                                    )
                              ? (_openBlock(), _createBlock(_component_PlantDevicesSettings, {
                                  key: 0,
                                  device: _ctx.selectedDevice,
                                  desktopId: _ctx.currentPlant.desktopId
                                }, null, 8, ["device", "desktopId"]))
                              : _createCommentVNode("", true),
                            (_ctx.selectedDevice.isAnomaly)
                              ? (_openBlock(), _createBlock(_component_PlantDevicesAnomaly, {
                                  key: 1,
                                  device: _ctx.selectedDevice
                                }, null, 8, ["device"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_30, [
                  _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("plantDetail.selectDevice")), 1)
                ]))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_32, [
            _createVNode("h1", null, _toDisplayString(_ctx.$t("AppResource.NoDevices")), 1),
            _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("AppResource.AddNewNew")), 1)
          ]))
    ])
  ], 64))
}